import { AppContext, EMPTY_OBJECT } from 'commons-ui';
import { useContext } from 'react';
import { USER_SEGMENT_RESOURCES, URL } from '../../helper';
import useService from '../../useService';

export const makeActionHandler = (action: any, params: any) => {
	const { history, rowData = EMPTY_OBJECT, setConfirmationDialog, setForceUpdateRows } = params;
	const { showAlert } = useContext(AppContext);
	const { requestUpdateFeatureSegments } = useService();
	switch (action.id) {
		case 'add':
			return () => {
				history.push({
					pathname: `${URL[USER_SEGMENT_RESOURCES.featureSegments]}/create`
				});
			};
		case 'edit':
			return () => {
				history.push({
					pathname: `${URL[USER_SEGMENT_RESOURCES.featureSegments]}/edit`,
					state: {
						rowData
					}
				});
			};
		case 'delete': {
			const deleteMapping = async () => {
				await requestUpdateFeatureSegments(
					{
						...rowData,
						isDeleted: true
					},
					showAlert
				);
				setForceUpdateRows(true);
			};

			return () => {
				setConfirmationDialog({
					show: true,
					header: 'Permanently Delete this mapping?',
					handleAlertConfirmation: deleteMapping
				});
			};
		}
		case 'toggle': {
			const isCurrentlyEnabled: boolean = rowData.enabled;
			const toggleMapping = async () => {
				await requestUpdateFeatureSegments(
					{
						...rowData,
						enabled: !isCurrentlyEnabled
					},
					showAlert
				);
				setForceUpdateRows(true);
			};

			return () => {
				setConfirmationDialog({
					show: true,
					header: `${isCurrentlyEnabled ? `Disable` : `Enable`} this mapping?`,
					handleAlertConfirmation: toggleMapping
				});
			};
		}
		default:
			return () => {
				return null;
			};
	}
};
